import React from 'react';
import PropTypes from 'prop-types';

import { ALBUM_FOLDER_PURCHASE_OPTIONS_INTERSTITIAL_MODAL } from '../../constants/modals';
import withModal from '../../components/global/modal/withModal';
import Button from '../../components/global/Button';
import PhotoPassIcon from '../../components/icons/PhotoPassIcon';
import PreviewOnlyIcon from '../../components/icons/PreviewOnlyIcon';

const propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};

const PurchasingOptionsInfoInterstitial = ({ onRequestClose }) => (
  <div className="p-2 text-center">
    <PhotoPassIcon size="34" />
    <h4 className="text-base">Photo Pass</h4>
    <p className="mb-3">
      Receive all your current and <em>future</em> photos that your ID appears
      in. You&rsquo;ll receive your pics free of watermarks and ready to
      download in hi-res, plus you&rsquo;ll be able to invite your family
      members to your photo stream!
    </p>

    <PreviewOnlyIcon size="40" />
    <h4 className="text-base">Preview Only</h4>
    <p>
      Join for free and receive watermarked proofs as soon as Waldo finds your
      photos. You&rsquo;ll be able to choose and purchase them individually.
    </p>

    <Button
      btnBlock
      className="mt-3"
      btnStyle="success-vibrant"
      onClick={onRequestClose}
    >
      Got it
    </Button>
  </div>
);

PurchasingOptionsInfoInterstitial.propTypes = propTypes;

export default withModal(PurchasingOptionsInfoInterstitial, {
  name: ALBUM_FOLDER_PURCHASE_OPTIONS_INTERSTITIAL_MODAL,
  size: 'sm',
  hideHeader: true,
});
